<template>
  <div
    aria-live="assertive"
    class="z-50 fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
  >
    <div class="w-full flex flex-col items-center space-y-4 sm:items-end">
      <transition
        enter-active-class="transform ease-out duration-300 transition"
        enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
        enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
        leave-active-class="transition ease-in duration-100"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          v-if="canShowToast"
          class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden"
        >
          <div class="p-4">
            <div class="flex items-start">
              <div class="flex-shrink-0">
                <CheckCircleIcon
                  v-if="toastMessage.type === 'success'"
                  class="h-6 w-6 text-green-400"
                  aria-hidden="true"
                />
                <XCircleIcon
                  v-if="toastMessage.type === 'error'"
                  class="h-6 w-6 text-red-600"
                  aria-hidden="true"
                />
              </div>
              <div class="ml-3 w-0 flex-1 pt-0.5">
                <p
                  class="text-sm font-medium text-gray-900"
                  v-text="toastMessage.message"
                />
                <p
                  v-if="toastMessage.description"
                  class="mt-1 text-sm text-gray-500"
                  v-text="toastMessage.description"
                />
              </div>
              <div class="ml-4 flex-shrink-0 flex">
                <button
                  class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  @click="show = false"
                >
                  <span class="sr-only">Close</span>
                  <XMarkIcon
                    class="h-5 w-5"
                    aria-hidden="true"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue';
import { router } from '@inertiajs/vue3';
import { XMarkIcon } from '@heroicons/vue/24/solid';
import useAppData from '@/composables/useAppData';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/vue/24/outline';

const show = ref(true);
const timer = ref(null);

const { toastMessage } = useAppData();

const canShowToast = computed(() => show.value && toastMessage.value !== null);

/**
 * Evaluate if should show toast message.
 */
function showToast() {
  if (toastMessage.value !== null) {
    show.value = true;
    timer.value = setTimeout(() => show.value = false, 5000);
  } else if (timer.value !== null) {
    clearTimeout(timer.value);
  }
}

showToast();
router.on('finish', () => showToast());
</script>
